quoteModule.factory("VehicleInfo",['vehicleDefinitionService', function(vehicleDefinitionService) {
    var VehicleInfo = function(ignoreProviderReq){
        this.vin = "";
        this.year = "";
        this.makeId = "";
        this.makeName = "";
        this.modelId = "";
        this.modelName = "";
        this.odometer = "";
        this.dateOfSale = new Date();
        this.inService = null;
        this.vehicleUsage = "";
        this.vehicleCert = "";
        this.vehicleSaleType = "";
        this.vehicleType = "AUTO";
        this.newUsed = "";
        this.rvType = "";
        this.rvManuMiles = null;
        this.rvManuMonths = null;
        if (typeof ignoreProviderReq == undefined){
            vehicleDefinitionService.getProviderRequiresInservice()
            .then(function gotValue(val){
                this.inserviceRequired = val;
            });
        }
    }


    VehicleInfo.prototype.clearVehicle = function() {
        this.vehicleType = 'AUTO';
        this.vin = 
            this.year = 
            this.makeId =
            this.makeName = 
            this.modelId = 
            this.modelName = 
            this.odometer = 
            this.vehicleUsage =
            this.vehicleCert =
            this.vehicleSaleType =
            this.newUsed =
            this.rvType = "";
        this.vehicleType = "AUTO";
        this.rvManuMiles =
            this.rvManuMonths = null;

        this.dateOfSale = new Date();
        this.inService = null;
        vehicleDefinitionService.getProviderRequiresInservice()
            .then(function gotValue(val){
                this.inserviceRequired = val;
            });
    }
    
    //validation of deal data for saving a quote.. not much here because we really don't
    // require deal data to save a quote
    VehicleInfo.prototype.dataReadyToSaveQuote = function() {
        var dataReady = true;
        var odo = parseInt(this.odometer)
        var dos = Date.parse(this.dateOfSale);
        if (this.vehicleType != 'RV') {
            dataReady = ((this.vin != 'undefined' && this.vin.length > 0) || (this.makeId.length > 0 && this.modelId.length > 0)) && odo != NaN && odo >= 0 && dos != NaN;
            if (this.inserviceRequired){
                dataReady &= this.inService!=null && this.inService != NaN;
            }
        }else{
            try {
                dataReady = this.rvType != null && parseInt(this.year) > 0 && ((parseInt(this.rvManuMiles) > 0 && this.rvType != 'TOWABLE') || (this.rvType == 'TOWABLE')) && parseInt(this.rvManuMonths) > 0;
            }catch(e){
                dataReady = false;
            }
        }
        return dataReady;
    }

    VehicleInfo.prototype.dataReadyToRate = function() {
        // if 'Manufacturer` is specified, then we need to have an inservice date.
        var dataReady = false;
        if (this.vehicleType != 'RV') {
            dataReady = this.odometer >= 0 &&
                this.dateOfSale &&
                (this.vehicleCert != 'Manufacturer' || this.inService);
            if (this.inserviceRequired){
                dataReady &= this.inService!=null && this.inService != NaN;
            }
        }else{
            try {
                dataReady = this.odometer >= 0 &&
                    this.rvType != null && this.rvType != '' &&
                    ((parseInt(this.rvManuMiles) > 0 && this.rvType != 'TOWABLE') || (this.rvType == 'TOWABLE')) &&
                    parseInt(this.rvManuMonths) > 0 &&
                    parseInt(this.year) > 0
                if (this.vin){
                    dataReady &= this.vin.length === 17
                }
            }catch(e){ dataReady = false; }
        }
        return dataReady;
    }

    VehicleInfo.prototype.consumeFromRateQuoteRetrieve = function(vehRateInfo, partnerFields) {
        if (vehRateInfo) {
            this.vin = vehRateInfo.OriginalVehicleIdentification;
            this.year = vehRateInfo.Model.ModelYear;
            this.makeId = vehRateInfo.Make.InternalMakeId;
            this.makeName = vehRateInfo.Make.MakeName;
            this.modelId = vehRateInfo.Model.InternalModelId;
            this.modelName = vehRateInfo.Model.SeriesName;
        }
        if (partnerFields){
            var keys = partnerFields.map(function(ele) { return ele.key; });
            var values = partnerFields.map(function(ele) { return ele.value; });
            if (keys.indexOf('rvType')>=0){
                this.rvType = values[keys.indexOf('rvType')];
                this.rvManuMiles = parseInt(values[keys.indexOf('rvManuWarrMiles')]);
                this.rvManuMonths = parseInt(values[keys.indexOf('rvManuWarrMonths')]);
                this.year = parseInt(values[keys.indexOf('rvModelYear')]);
                this.vehicleType = 'RV';
            }
            if (keys.indexOf('vehicleNewUsed')>=0){
                this.vehicleSaleType = this.newUsed = values[keys.indexOf('vehicleNewUsed')];
            }
        }
    }
    return VehicleInfo;
}]);

